import React from "react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

const LAST_UPDATED = "18 de febrero de 2026";

export default function Terms() {
  return (
    <Layout>
      <div className="max-w-[820px] mx-auto px-5 py-8 text-[#c7d0e1]" data-testid="terms-page">
        <h1 className="font-pixel text-[16px] text-glow-green mb-2">◆ TERMS OF SERVICE</h1>
        <p className="text-[11px] text-[#8b95a9] mb-6">Última actualización: {LAST_UPDATED}</p>

        <p className="mb-5 text-[13px] leading-relaxed">
          Bienvenido/a a <strong>CRYPTOBOOM</strong> ("el Servicio"), operado por el ecosistema
          UNI2Chain / CBC Business Club ("nosotros"). Al acceder al Servicio aceptas estos Términos
          de Servicio. Si no estás de acuerdo, por favor no lo utilices.
        </p>

        <Section title="1. Elegibilidad">
          Debes tener al menos <strong>13 años</strong> para crear una cuenta y <strong>18 años</strong>{" "}
          para convertir BOOM Credits (BC) a tokens UNI2 u operar en la wallet on-chain. En ciertas
          jurisdicciones la edad mínima puede ser mayor; es tu responsabilidad conocer las leyes
          aplicables en tu país.
        </Section>

        <Section title="2. Cuenta y seguridad">
          Eres responsable de la confidencialidad de tu contraseña y del uso de tu cuenta. Notifica
          inmediatamente cualquier uso no autorizado. Podemos suspender o cerrar cuentas que violen
          estos Términos o exhiban comportamiento fraudulento (múltiples cuentas, bots, exploits).
        </Section>

        <Section title="3. BOOM Credits (BC) y tokens UNI2">
          Los BC son una <strong>moneda in-game sin valor monetario intrínseco</strong>. Son convertibles
          a tokens UNI2 según las tasas publicadas en la Sección "Earn" del sitio, sujetas a cambio y
          disponibilidad del pool de conversión. Los tokens UNI2 son activos digitales cuyo valor de
          mercado puede fluctuar; no garantizamos precio, liquidez ni rentabilidad. No prestamos
          servicios de inversión, custodia ni intermediación financiera.
        </Section>

        <Section title="4. Conducta prohibida">
          Te comprometes a no: (a) usar bots, scripts, emuladores o cualquier herramienta que
          automatice el gameplay; (b) crear múltiples cuentas para farmear referidos o recompensas;
          (c) manipular puntuaciones, credentials o transacciones; (d) usar el Servicio para
          actividades ilegales, blanqueo de capitales o financiación del terrorismo; (e) hostigar a
          otros usuarios o publicar contenido ilegal, dañino u ofensivo. Reservamos el derecho a
          revertir recompensas obtenidas fraudulentamente.
        </Section>

        <Section title="5. Anti-cheat">
          El Servicio ejecuta validaciones automáticas de las partidas enviadas. Sesiones con
          patrones anómalos pueden ser rechazadas o revertidas. Un ban temporal puede aplicar
          automáticamente. Puedes apelar escribiendo a soporte.
        </Section>

        <Section title="6. Compras y NFTs">
          Las compras en el shop se pagan en BC y son <strong>finales, no reembolsables</strong>
          salvo defecto técnico verificado. Los NFTs se emiten en la red UNI2Chain como ERC-721; su
          existencia depende de la blockchain, no de nuestros servidores. No garantizamos que existan
          mercados secundarios para los NFTs.
        </Section>

        <Section title="7. Propiedad intelectual">
          Todo el contenido del Servicio (código, arte, música, marca) es propiedad de UNI2Chain /
          CBC Business Club o sus licenciantes. Se te otorga una licencia limitada, revocable, no
          exclusiva y no transferible para usar el Servicio con fines personales. Los NFTs
          adquiridos te otorgan derecho de uso personal sobre la imagen asociada, pero no la
          transfieren.
        </Section>

        <Section title="8. Datos personales">
          El tratamiento de tus datos se rige por nuestra <Link className="text-[#2ecc71]" to="/privacy">Política de Privacidad</Link>.
        </Section>

        <Section title="9. Descargos y limitación de responsabilidad">
          El Servicio se ofrece "TAL CUAL" sin garantías de disponibilidad, exactitud o adecuación a
          un fin particular. En ningún caso responderemos por daños indirectos, incidentales,
          especiales o consecuentes, ni por pérdida de tokens derivada de acciones on-chain
          irreversibles, fluctuación de precios, forks de la red o vulnerabilidades de smart
          contracts ajenas a nuestro control.
        </Section>

        <Section title="10. Cambios en el Servicio y en los Términos">
          Podemos modificar el Servicio, las tasas de conversión, la tokenomía y estos Términos en
          cualquier momento. Los cambios entrarán en vigor tras publicarse en el sitio. El uso
          continuado del Servicio implica aceptación de la nueva versión.
        </Section>

        <Section title="11. Ley aplicable">
          Estos Términos se rigen por las leyes del lugar de constitución del operador. Cualquier
          disputa se resolverá en los tribunales competentes de dicha jurisdicción, salvo derecho
          imperativo del consumidor.
        </Section>

        <Section title="12. Contacto">
          Escríbenos a <a href="mailto:support@cryptoboom.io" className="text-[#2ecc71]">support@cryptoboom.io</a> para preguntas, apelaciones o solicitudes.
        </Section>

        <p className="mt-8 text-[11px] text-[#8b95a9]">
          Este documento es una versión inicial. Recomendamos consulta legal profesional antes del
          lanzamiento público en cada jurisdicción objetivo.
        </p>
      </div>
    </Layout>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-5">
      <h2 className="font-pixel text-[10px] text-[#f7931a] mb-2 tracking-wide">{title}</h2>
      <p className="text-[13px] leading-relaxed text-[#c7d0e1]">{children}</p>
    </section>
  );
}
